var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 text-center"},[_c('div',{class:['lds-dual-ring', {visible: _vm.display}]})])}
var staticRenderFns = []

export { render, staticRenderFns }